import React, {Component} from 'react';
import GA from '../lib/GoogleAnalyticsWrapper'
import './ConfirmationView.css';
import AlertContainer from 'react-alert'

const styles = {
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: '10%',
    alignItems: 'center',
    justifyContent: 'center'
  },
  footer: {
    position: 'absolute',
    bottom: 0,
    left:0,
    marginBottom: '7%',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center'
  }
};

export default class ConfirmationView extends Component {
  alertOptions = {
    offset: 14,
    position: 'bottom left',
    theme: 'light',
    time: 5000,
    transition: 'scale'
  }

  checkResult() {
    this.props.history.push("/result?email=" + this.props.email);
  }

  tryAgain() {
    this.props.history.push('/');
  }

  render () {
    GA.pageview("confirmation");
    let buttons = () =>
      <div style={styles.buttonsContainer}>
        <button className='btn-again' onClick={() => this.tryAgain()}>Try Again</button>
        <button className='btn-submit' onClick={() => this.checkResult()}>Check My Results</button>
      </div>;

    return (
      <div className="confirmation-container" style={{position:'absolute', top:0, left:0, right:0, bottom:0}}>

        <AlertContainer ref={a => this.msg = a} {...this.alertOptions} />
        <div className="content">
          <div className="icon">
          </div>
          <h1>Your request has been successfully submitted</h1>
          <h4>Your result will be ready soon!</h4>

          {buttons()}

          <div style={styles.footer}>
            <p>Questions?</p>
            <a>info@alphasmithy.com</a>
          </div>
        </div>

      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/ConfirmationView.js